module.exports = __webpack_public_path__ + "static/media/points_example.a23d2dcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/points_example.png
// module id = 8684
// module chunks = 0